import { z } from 'zod';
import { employmentApi } from '../../../api';
import { EMPLOYMENT_EVENT_TYPES } from '../../../../constants/employmentEventTypes';
import { EVENT_ACTOR_TYPES } from '../../../../constants/employmentActorTypes';
import { employmentEpisodeIdSchema } from '../episodeAddress';

/**
 * Validation schema for resignation withdrawal
 */
const withdrawResignationSchema = z.object({
  employeeId: z.uuid(),
  employmentEpisodeId: employmentEpisodeIdSchema, // ADR-155 §6
  reason: z.string().min(1, 'Reason is required')
});

/**
 * Withdraw Resignation
 *
 * @param {Object} payload - Resignation withdrawal data
 * @param {string} payload.employeeId - Required
 * @param {string} payload.reason - Required
 * @param {string} [actorType='User'] - Actor type (System, User, Import)
 * @returns {Promise<Object>}
 * @throws {z.ZodError} - If validation fails
 */
export const withdrawResignation = async (payload, actorType = EVENT_ACTOR_TYPES.USER) => {
  // Validate payload
  const validatedPayload = withdrawResignationSchema.parse(payload);

  return await employmentApi.triggerEmploymentEvents({
    metadata: {
      actorType
    },
    events: [{
      type: EMPLOYMENT_EVENT_TYPES.RESIGNATION_WITHDRAWN,
      payload: validatedPayload
    }]
  });
};
